import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import Exam from '../../models/exam'
import { ROUTER_NAME } from '../../router'
import api from '../../../api/v2/api'
import User from '../../models/user'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExamButton',
  props: {
    exam: {},
    user: {}
  },
  setup(__props: any) {

const props = __props

const router = useRouter()
const buttonState = ref<'Apply' | 'Buy' | 'Continue' | 'Result'>('Apply')

const title = computed(() => {
  const userExam = props.exam.userExams.find(userExam => userExam.userId == props.user.id)
  if (userExam) {
    if (userExam.finishedAt) {
      buttonState.value = 'Result'
      return 'WEBテストの結果をみる'
    }
    buttonState.value = 'Continue'
    return 'WEBテストを受け続ける'
  }

  if (props.exam.price && !props.user.hasExamSubscription) {
    buttonState.value = 'Buy'
    return `${props.exam.price.toLocaleString()}円でWEBテストを受ける`
  }
  buttonState.value = 'Apply'
  return '今すぐWEBテストを受ける'
})

const buttonAction = async () => {
  switch(buttonState.value) {
    case 'Apply':
      await api.exam.join(props.exam.id)
      return router.push({
        name: ROUTER_NAME.EXAM_SHOW,
        params: {
          examId: props.exam.id.toString()
        }
      })
    case 'Buy':
      return router.push({
        name: ROUTER_NAME.EXAM_PURCHASE,
        params: {
          examId: props.exam.id.toString()
        }
      })
    case 'Continue':
      return router.push({
        name: ROUTER_NAME.EXAM_SHOW,
        params: {
          examId: props.exam.id.toString()
        }
      })
    case 'Result':
      return router.push({
        name: ROUTER_NAME.EXAM_RESULT,
        params: {
          examId: props.exam.id.toString()
        },
        query: {
          user_exam_id: props.exam.userExam.id.toString()
        },
      })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    color: "warning",
    size: "large",
    variant: "flat",
    class: "text-white",
    onClick: buttonAction
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(title.value), 1 /* TEXT */)
    ]),
    _: 1 /* STABLE */
  }))
}
}

})